import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class updateDriversNodoInRTDBCommand extends IRequestCommand<
IUpdateDriversNodoInRTDBResponse,
  ErrorDetails,
  IUpdateDriversNodoInRTDBParameters> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/drivers/{driverId}/updDriversNodoRTDB/{nodo}'

  override setParameters(parameters: IUpdateDriversNodoInRTDBParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId ? parameters.carrierId : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{driverId}',
      parameters.carrierId ? parameters.driverId : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{nodo}',
      parameters.nodo ? parameters.nodo : ''
    );
  }
}

export interface IUpdateDriversNodoInRTDBParameters {
  carrierId: string;
  driverId: string;
  nodo: string
}

export interface IUpdateDriversNodoInRTDBResponse extends ICommandResponse {
}
